import { GKButton, GKModal, Grid2, Typography } from "components";
import { useMutation } from "hooks/useQueries";
import axiosInstance from "utils/axiosInstance";
import { GKModalProps } from "utils/commonInterface";

const HoldingReportModal = (props: GKModalProps) => {
  const { open, setOpen } = props;

  const {
    mutate: handleCombinedHoldingsGenerateReport,
    isLoading: combinedHoldingLoading,
  } = useMutation({
    mutationFn: (data) =>
      axiosInstance.get(`/portfolios/combined_holdings/csv/${data}/`),
    onSuccess: (response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `combined_holdings-${new Date().getTime()}.csv`,
      );
      document.body.appendChild(link);
      link.click();
      setOpen(false);
    },
  });

  return (
    <GKModal
      width={"30%"}
      modalTitle={"All Holding Report"}
      open={open}
      setOpen={setOpen}
      footer={
        <Grid2 container gap={1} justifyContent={"flex-end"}>
          <GKButton
            color="dark"
            variant="outlined"
            size="medium"
            onClick={() => setOpen(false)}
          >
            No
          </GKButton>
          <GKButton
            variant="contained"
            size="medium"
            loading={combinedHoldingLoading}
            onClick={() => handleCombinedHoldingsGenerateReport("report")}
          >
            Yes
          </GKButton>
        </Grid2>
      }
    >
      <Grid2 container>
        <Typography fontWeight={500} fontSize={16}>
          This will generate a report consisting of all holdings across all the
          portfolios in this account as of today. Do you want to generate it?
        </Typography>
      </Grid2>
    </GKModal>
  );
};

export default HoldingReportModal;
